import { gql, GraphQLClient } from 'graphql-request';

import { NetworkIds } from '~config/rpcConfig';
import { VestaGraphConfig } from '~config/vestaGraphConfig';

import Assets from './assets';
import Global from './global';
import GlobalAccruedFees from './global/accruedFees';
import Liquidations from './liquidations';
import Redemptions from './redemptions';
import SavingModule from './savingModule';
import StabilityPool from './stabilityPool';
import User from './user';
import Vaults from './vaults';

export default class VestaSubgraph {
  public global: Global;
  public accruedFees: GlobalAccruedFees;
  public user: User;
  public assets: Assets;
  public liquidations: Liquidations;
  public redemptions: Redemptions;
  public vaults: Vaults;
  public stabilityPool: StabilityPool;
  public savingModule: SavingModule;

  public networkId: NetworkIds;
  private client: GraphQLClient;

  constructor({
    url = VestaGraphConfig[NetworkIds.ARBITRUM_ONE],
    networkId = NetworkIds.ARBITRUM_ONE,
  }: {
    url?: string;
    networkId?: NetworkIds;
  }) {
    this.client = new GraphQLClient(url);
    this.networkId = networkId;
    this.global = new Global(this.client, networkId);
    this.accruedFees = new GlobalAccruedFees(this.client, networkId);
    this.user = new User(this.client, networkId);
    this.assets = new Assets(this.client, networkId);
    this.liquidations = new Liquidations(this.client, networkId);
    this.redemptions = new Redemptions(this.client, networkId);
    this.vaults = new Vaults(this.client, networkId);
    this.stabilityPool = new StabilityPool(this.client, networkId);
    this.savingModule = new SavingModule(this.client, networkId);
  }

  async checkBlock(block: number) {
    const dummuCheckQuery = gql`
      query plz_check_block($block: Int) {
        assets(first: 1, block: { number: $block }) {
          name
        }
      }
    `;

    await this.client.request(dummuCheckQuery, { block });
  }
}
